module.exports = __webpack_public_path__ + "img/pressButton.c01cc558.png";